(ns kyber.kyber-db.activity-mindset-readiness-diagnostic)

(defn ->ident-key
  "This is used to troubleshoot readiness & mindset from the learner (Super User Only)"
  [{activity-uuid :activity/uuid}]
  (str "activity-diagnostic_activity-" activity-uuid))

(def model
  {:ident-key ->ident-key})
